var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Context } from '~/ErrorHandler/Context';
export var ErrorHandler = function (_a) {
    var handler = _a.handler, fallback = _a.fallback, children = _a.children;
    var _b = React.useState(function () { return new Map(); }), errorMessages = _b[0], setErrorMessages = _b[1];
    var _c = React.useState(null), jsErrorMessage = _c[0], setJsErrorMessage = _c[1];
    var parentContext = React.useContext(Context);
    var context = React.useMemo(function () { return ({
        errorMessages: errorMessages,
        fallback: fallback !== null && fallback !== void 0 ? fallback : parentContext.fallback,
        handler: handler !== null && handler !== void 0 ? handler : parentContext.handler,
        setErrorMessages: setErrorMessages,
    }); }, [handler, fallback, errorMessages, parentContext]);
    var catchJsError = React.useCallback(function (error, errorInfo) {
        setJsErrorMessage(context.handler(error, errorInfo));
    }, [context]);
    return (<ErrorBoundary onCatch={catchJsError}>
			<Context.Provider value={context}>
				{jsErrorMessage !== null ? context.fallback(jsErrorMessage) : children}
			</Context.Provider>
		</ErrorBoundary>);
};
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return null;
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.props.onCatch(error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        return <>{this.props.children}</>;
    };
    return ErrorBoundary;
}(React.PureComponent));
